import React from 'react';
import './FavoriteSelectorAtom.scss';

interface FavoriteSelectorAtomProps {
  isSelected: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick: () => void;
}

const FavoriteSelectorAtom: React.FC<FavoriteSelectorAtomProps> = ({
  isSelected,
  className = '',
  style,
  onClick,
}) => {
  return (
    <div
      className={`favorite-selector-icon ${className} ${
        isSelected ? 'selected' : ''
      }`}
      style={style}
      onClick={onClick}
      role="button"
      aria-label="Favorite User Icon"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        className="icon"
      >
        <path
          d="M11 1.73l3.09 6.26 6.91 1-5 4.87 1.18 6.88L11 17.27l-6.18 3.27 1.18-6.88-5-4.87 6.91-1L11 1.73z"
          className="star-path"
        />
      </svg>
    </div>
  );
};

export default FavoriteSelectorAtom;
